module.exports = __webpack_public_path__ + "static/media/0010.0775f5d0.svg";